import {
  SEOBreadcrumbJsonLd,
  SEOCarouselJsonLd,
  Seo,
} from '@redbubble/next-seo';
import type { SEOMetadata } from '../../types';

interface PageMetadataProps {
  seoMetadata: SEOMetadata;
}

export const PageMetadata: React.FC<PageMetadataProps> = ({ seoMetadata }) => {
  const {
    filteredTitle,
    robots,
    pageDescription,
    canonicalURL,
    paginationLinkTags,
    openGraph,
    productsJsonLdData,
    breadcrumbsJsonLdData,
  } = seoMetadata;

  return (
    <>
      <Seo
        title={filteredTitle}
        description={pageDescription}
        canonical={canonicalURL ?? undefined}
        openGraph={openGraph}
        additionalLinkTags={paginationLinkTags}
        nofollow={robots?.includes('nofollow')}
        noindex={robots?.includes('noindex')}
      />
      {productsJsonLdData.length > 0 && (
        <SEOCarouselJsonLd data={productsJsonLdData} />
      )}
      {breadcrumbsJsonLdData.length > 0 && (
        <SEOBreadcrumbJsonLd data={breadcrumbsJsonLdData} />
      )}
    </>
  );
};
